import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import React from 'react';
import Icon from '../components/Icon/Icon.js';

var IconEmail = function IconEmail(_ref) {
  var title = _ref.title,
      filled = _ref.filled,
      otherProps = _objectWithoutProperties(_ref, ["title", "filled"]);

  return /*#__PURE__*/React.createElement(Icon, otherProps, filled ? /*#__PURE__*/React.createElement("svg", {
    title: title,
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 6a3 3 0 013 3v30a3 3 0 01-3 3H3a3 3 0 01-3-3V9a3 3 0 013-3h42zm-2.517 3.398L24 26.458 5.517 9.399a1.5 1.5 0 10-2.035 2.204l19.5 18a1.5 1.5 0 002.035 0l19.5-18a1.5 1.5 0 10-2.035-2.204z"
  })) : /*#__PURE__*/React.createElement("svg", {
    title: title,
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 6a3 3 0 013 3v30a3 3 0 01-3 3H3a3 3 0 01-3-3V9a3 3 0 013-3h42zm0 4.981L25.023 29.597a1.5 1.5 0 01-1.926.1l-.12-.1L3.002 10.982V39h42V10.981zM42.725 9H5.273L24 26.45 42.725 9z"
  })));
};

export default IconEmail;
